import styled, { css } from 'styled-components';
import { media } from '~constants/media';

const leftBorderCSS = css`
  &:before {
    position: absolute;
    content: '';
    height: 80%;
    top: 18%;
    left: 0;
    width: 1px;
    background-color: #f2f2f2;
  }
`;

const borderWithPaddingCSS = css`
  &:not(:first-child) {
    padding-left: 30px;
    ${leftBorderCSS}
  }
`;

export const Block = styled.div<{ desktopSmallView?: boolean }>`
  position: relative;

  &:not(:last-child) {
    padding-right: 0;
  }

  &:nth-child(even) {
    padding-left: 47px;
    ${leftBorderCSS}
  }

  ${media.lg`
    &:not(:last-child) {
      padding-right: 30px;
    }
  `}

  ${({ desktopSmallView }) => css`
    ${media.lg`
        ${!desktopSmallView && borderWithPaddingCSS}
      `}
  `}
`;

export const Label = styled.div`
  font-size: 14px;
  line-height: 1;
  font-weight: 300;
  color: #706f6f;
  white-space: nowrap;
`;

export const Value = styled.div`
  margin-top: 5px;
  font-size: 14px;
  line-height: 1;
  font-weight: 600;
  color: #706f6f;
  white-space: normal;

  ${media.lg`
    font-size: 18px;    
  `}
`;
